module.exports = __webpack_public_path__ + "img/info_round_p.742c91bc.svg";